import { Pipe, PipeTransform } from '@angular/core';

import { AssetFragment } from '../../common/generated-types';
import { FALLBACK_ASSET_URL, VALID_ASSET_FORMATS } from '../../common/constants';

@Pipe({
    name: 'assetPreview',
})
export class AssetPreviewPipe implements PipeTransform {
    transform(asset?: AssetFragment, ...args: Array<string | number>): string {
        if (!asset) {
            return FALLBACK_ASSET_URL;
        }
        const imageUrl = asset.imageUrl || asset.preview || FALLBACK_ASSET_URL;
        const previewUrl = this.getRelativePath(imageUrl);
        const fp = asset.focalPoint ? `&fpx=${asset.focalPoint.x}&fpy=${asset.focalPoint.y}` : '';
        if (args.length === 0 && !asset.focalPoint) {
            return previewUrl;
        }
        const formatQuery = this.getFormatQuery(args);
        const query = this.getSizeQuery(args);
        return `${previewUrl}?${query}${fp}${formatQuery}`;
    }

    private getRelativePath(url: string): string {
        try {
            const parsedUrl = new URL(url);
            return parsedUrl.pathname;
        } catch (error) {
            return url;
        }
    }

    private getSizeQuery(args?: Array<string | number>): string {
        if (!args) {
            return `preset=thumb`;
        }
        if (args.length === 1) {
            if (typeof args[0] === 'string') {
                return `preset=${args[0]}`;
            } else {
                return `w=${args[0]}`;
            }
        } else {
            return `w=${args[0]}&h=${args[1]}`;
        }
    }

    private getFormatQuery(args?: Array<string | number>): string {
        if (!args || args.length === 0) {
            return '';
        }
        let selectedFormat: string | undefined;
        const cleanedArgs: Array<string | number> = [];
        for (const arg of args) {
            if (typeof arg === 'string' && VALID_ASSET_FORMATS.includes(arg.toLowerCase())) {
                if (!selectedFormat) {
                    selectedFormat = arg.toLowerCase();
                }
            } else {
                cleanedArgs.push(arg);
            }
        }
        // mutate the original array so getSizeQuery sees only non-format params
        args.length = 0;
        args.push(...cleanedArgs);
        return selectedFormat ? `&format=${selectedFormat}` : '';
    }
}